const escapeList: [string, string][] = [
	['&', '&amp;'],
	['<', '&lt;'],
	['>', '&gt;'],
	['"', '&quot;'],
	["'", '&#x27;'],
	['`', '&#x60;'],
]

export function escapeHtml(text: string): string {
	return escapeList.reduce((v, [search, replace]) => v.replaceAll(search, replace), text)
}
